import { i } from "./atoms-v21056.js";
import { _ as o } from "./atoms-v21057.js";
import { _ as s } from "./atoms-v21058.js";
import { t as a } from "./atoms-v21059.js";
var m = i, n = o, _ = s, f = a;
function p(r, t) {
  return m(r) ? r : n(r, t) ? [r] : _(f(r));
}
var c = p;
export {
  c as _
};
